module.exports = __webpack_public_path__ + "img/9788990809445.70947bfb.jpg";